// Estado de uma mensagem agendada, como a tela mostra.
//
// O banco guarda PENDENTE / AGENDADA / ENVIADA / ERRO. Para o usuário isso
// vira três estados:
// - "sent": já saiu;
// - "attention": deu erro, ou o horário passou e ela não saiu (por exemplo,
//   servidor fora do ar na hora). O backend usa a mesma tolerância;
// - "pending": ainda vai sair.

export const OVERDUE_GRACE_MS = 2 * 60 * 1000;

export const scheduleState = (schedule, now = Date.now()) => {
  if (!schedule) return "pending";
  const status = String(schedule.status || "").toUpperCase();
  if (schedule.sentAt || status === "ENVIADA") return "sent";
  if (status === "ERRO") return "attention";
  const sendAt = new Date(schedule.sendAt).getTime();
  if (!Number.isNaN(sendAt) && sendAt < now - OVERDUE_GRACE_MS) return "attention";
  return "pending";
};

// Motivo mostrado ao usuário. `errorMessage` vem do envio que falhou.
export const attentionReason = (schedule) => {
  const detail = String(schedule?.errorMessage || "").trim();
  if (String(schedule?.status || "").toUpperCase() === "ERRO") {
    return detail
      ? `Não foi possível enviar: ${detail}`
      : "Não foi possível enviar. Confira se a conexão do WhatsApp está ativa.";
  }
  return "O horário passou e a mensagem não foi enviada.";
};

// "Hoje", "Amanhã" ou "ter, 27 out" — rótulo do grupo de um dia
const WEEKDAYS = ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"];
const MONTHS = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

export const dayKey = (date) => {
  const d = startOfDay(new Date(date));
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
};

export const dayLabel = (date, now = new Date()) => {
  const d = startOfDay(new Date(date));
  const diff = Math.round((d - startOfDay(now)) / 86400000);
  const short = `${WEEKDAYS[d.getDay()]}, ${d.getDate()} ${MONTHS[d.getMonth()]}`;
  if (diff === 0) return `Hoje · ${short}`;
  if (diff === 1) return `Amanhã · ${short}`;
  if (diff === -1) return `Ontem · ${short}`;
  return short;
};

// Agrupa mantendo a ordem em que os itens chegaram
export const groupByDay = (schedules, now = new Date()) => {
  const groups = [];
  const index = {};
  schedules.forEach((s) => {
    const key = dayKey(s.sendAt);
    if (index[key] === undefined) {
      index[key] = groups.length;
      groups.push({ key, label: dayLabel(s.sendAt, now), items: [] });
    }
    groups[index[key]].items.push(s);
  });
  return groups;
};

// "em 2 h", "em 35 min", "há 3 h"
export const relativeTime = (date, now = Date.now()) => {
  const diff = new Date(date).getTime() - now;
  const abs = Math.abs(diff);
  const min = Math.round(abs / 60000);
  let text;
  if (min < 1) return "agora";
  if (min < 60) text = `${min} min`;
  else if (min < 60 * 24) text = `${Math.round(min / 60)} h`;
  else text = `${Math.round(min / 1440)} d`;
  return diff >= 0 ? `em ${text}` : `há ${text}`;
};
